import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'sm',
    fullName: 'Samoan',
    nativeName: 'Samoan',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "O loʻo oʻo mai se mea ofoofogia",
    landing_subtitle: "ArgVoid o se app ma le atinaʻeina o taaloga. Fa'aauau pea, o mea fou ua lata mai!",
    select_language: "Filifili Gagana",
    search_placeholder: "Su'e gagana...",
    terms_title: "Tuutuuga o Auaunaga",
    policy_title: "Faiga Fa'alilolilo",
    cookies_title: "Faiga Kuki",
    terms_content: `
        <strong>1. Taliaina o Tuutuuga</strong><br>
        I le mauaina o ArgVoid, ua talia nei Tuutuuga o Auaunaga. Afai e le malilie i ai nei tuutuuga, e le tatau ona faʻaaogaina le tautua.<br><br>

        <strong>2. Fa'aoga Fa'avae</strong><br>
        ArgVoid ma ana talosaga o loʻo tuʻuina atu "e pei ona iai" mo faʻamatalaga ma faʻamoemoega fatufatuaʻi. E tatau ona fa'aoga le auaunaga mo na'o fa'amoemoega fa'aletulafono.<br><br>

        <strong>3. Amioga Fa'asaina</strong><br>
        O le fa'aogaina o tulaga fa'aletonu i luga ole laiga, fa'asalalauina, po'o le taumafai e le fa'atagaina avanoa ile atina'e e matua fa'asaina lava.<br><br>

        <strong>4. Fa'ailoa</strong><br>
        Ole tulaga ma au'aunaga e mafai ona suia i so'o se taimi e aunoa ma se fa'aaliga. E leai se fa'amaoniga e tu'uina atu e uiga i le taimi fa'aoga po'o le avanoa o le auaunaga.
    `,
    policy_content: `
        <strong>1. Aoina o Fa'amatalaga</strong><br>
        E le manaʻomia e le faʻavae le faʻamaoniga a le tagata faʻaoga poʻo le fatuina o tala i le taimi nei. E leai ni fa'amatalaga e iloa ai le tagata lava ia (e pei o igoa po'o tuatusi imeli) o lo'o aoina mai tagata asiasi.<br><br>

        <strong>2. Fa'aoga Fa'amatalaga</strong><br>
        E mafai ona aoina au'ili'iliga fa'alilolilo e malamalama ai i fefa'ataua'iga o nofoaga ma fa'aleleia ai talosaga. O nei fa'amaumauga e le feso'ota'i i fa'asinomaga tagata ta'ito'atasi.<br><br>

        <strong>3. Au'aunaga Vaega Tolu</strong><br>
        E mafai ona fa'aogaina 'au'aunaga a isi vaega mo le talimalo ma au'aunaga au'ili'ili. O faiga fa'alilolilo a nei 'au'aunaga ta'itasi e pulea fa'amaumauga e le ta'ua o lo'o fa'agaioia i luga o latou atina'e.<br><br>

        <strong>4. Puipuiga o Fa'amatalaga</strong><br>
        Ua fa'atinoina faiga fa'apolopolo talafeagai e puipuia ai le tulaga. Ae ui i lea, e leai se auala e fa'asalalauina ai luga ole Initaneti e matua saogalemu.<br><br>
    `,
    cookies_content: `
        <strong>1. O a Kuki ma Fa'apitonu'u?</strong><br>
        O kuki ma su'esu'ega fa'apitonu'u e teu ai, o faila fa'amaumauga laiti ia o lo'o teuina i luga o le masini e manatua ai fa'atonuga o fa'atonuga i asiasiga.<br><br>

        <strong>2. Fa'aoga Fa'amoemoe</strong><br>
        Browser LocalStorage e fa'aoga sa'o e fa'asaoina ai fa'atulagaga, pei ole:<br>
        - Gagana fiafia<br>
        - Fa'atonuga fa'aoga fa'aoga (fa'ata'ita'iga, fa'atulagaina po'o fa'atūlaga autu)<br>
        - Talosaga le tumau cache<br><br>

        <strong>3. Leai se Su'ega</strong><br>
        E le fa'aogaina kuki ma fa'aputuga fa'apitonu'u mo fa'asalalauga po'o fa'amoemoega e tulituliloa ai isi vaega. O fa'amaumauga uma o lo'o teuina e fa'apitoa mo le fa'atinoga autu o le tulaga.<br><br>

        <strong>4. Pule</strong><br>
        E mafai ona fa'amama fa'amatalaga su'esu'e i so'o se taimi e ala i le fa'atulagaina o su'esu'ega, lea o le a toe setiina ai so'o se fa'alapotopotoga fa'apitonu'u.
    `,
    cookie_consent_text: "Matou te fa'aogaina kuki fa'avae e fa'amautinoa ai o lo'o fa'agaoioi sa'o le upegatafa'ilagi, e pei o le fa'agaoioia o lau vasega, fa'asaoina o lau gagana e te mana'o ai, ma isi fa'asologa masani.",
    read_policy: "Faitau Tulafono Kuki",
    support_title: "Faafesoota'i le Lagolago",
    support_subject_label: "Mataupu",
    support_message_label: "Savali",
    support_submit_button: "Auina atu le Feau",
    support_hint: "Fa'aaliga: O le a tatala ai lau talosaga imeli le aoga e lafo ai le fe'au.",
    support_success_msg: "Tatala lau imeli app...",
    support_error_msg: "Ua le mafai ona auina atu le fe'au. Faamolemole toe taumafai mulimuli ane.",
    explorer_title: "Su'esu'e",
    history_title: "Tala'aga",
    animation_title: "Fa'afiafiaga",
    config_title: "Fa'atonuga",
    tool_mouse: "Filifili (Ctrl+M)",
    tool_brush: "Pulu (Ctrl+B)",
    tool_brush_mode: "Faiga Fa'asolo (Malo/manino)",
    tool_eraser: "Tape (Ctrl+E)",
    tool_brush_size: "Fetuuna'i le Tele ole Fusi",
    tool_bucket: "Faatumu (Ctrl+F)",
    tool_eyedropper: "Matamata",
    tool_grid: "Grid (Ctrl+Shift+B)",
    tool_rotate: "Liliu (Ctrl+Shift+R)",
    tool_flip_h: "Su'e H (Ctrl+Shift+H)",
    tool_flip_v: "Su'e V (Ctrl+Shift+V)",
    tool_transpose: "Sui (Ctrl+Shift+T)",
    label_width: "Lautele",
    label_height: "Maualuluga",
    label_frames: "Numera o Fa'avaa",
    label_animation: "Sitaili Fa'afiafia",
    label_background_color: "Lanu Tulaga",
    label_interval: "Vaeluaga",
    tool_anim_config: "Fa'atonuga o ata",
    label_new_width: "Laulautele Fou",
    label_new_height: "Maualuluga Fou",
    label_apply: "Talosaga",
    label_colors: "Lanu",
    label_size: "Tele",
    label_tolerance: "Onosa'i",
    val_horizontal: "Fa'asagaga",
    val_vertical: "Tusa'o",
    val_sequence: "Fa'asologa",
    val_bounce: "Tu'u",
    val_random: "Fa'afuase'i",
    val_solid: "Malosi",
    val_clear: "manino",
    action_add_sheet: "Pepa Fou",
    action_import: "Fa'aulufale mai",
    action_export: "Lafoa'i atu",
    action_sort_projects: "Fa'avasega",
    sort_date_old: "Matua Muamua",
    sort_date_new: "Fou Muamua",
    sort_name_az: "Igoa (A-Z)",
    sort_name_za: "Igoa (Z-A)",
    action_new_sprite: "Sprite Fou",
    action_new_project: "Poloketi Fou",
    modal_save_all_title: "Faasaoina Suiga Uma",
    modal_save_all_desc: "Filifili aseta e teu:",
    modal_save_selected: "Faasao Filifilia",
    action_saved: "Faasaoina",
    modal_create_sprite_title: "Fausia Sprite Fou",
    modal_create_project_title: "Fausia Poloketi Fou",
    modal_add_sheet_title: "Faaopoopo Pepa Fou",
    modal_rename_sheet_title: "Toe faaigoa le Pepa",
    modal_rename_sprite_title: "Toe faaigoa Sprite",
    modal_delete_sprite_title: "Aveese le Sprite",
    modal_delete_project_title: "Aveese Poloketi",
    modal_delete_sheet_title: "Aveese le Pepa",
    placeholder_sprite_name: "Igoa",
    placeholder_project_name: "Igoa",
    placeholder_sheet_name: "Igoa",
    placeholder_new_name: "Igoa Fou",
    action_create: "Fausia",
    action_add: "Faaopoopo",
    action_rename: "Toe faaigoa",
    action_duplicate: "Fa'alua",
    action_delete: "Aveese",
    action_cancel: "Fa'aleaogaina",
    confirm_delete_sprite: "E te mautinoa e te mana'o e tape lenei sprite?",
    confirm_delete_project: "E te mautinoa e te mana'o e tape lenei poloketi? O sprites uma o le a aveesea.",
    confirm_delete_sheet: "E te mautinoa e te mana'o e tape lenei pepa?",
    err_select_sprite: "Fa'amolemole filifili muamua se sprite.",
    err_select_project: "Fa'amolemole filifili muamua se poloketi.",
    err_name_empty: "E le mafai ona gaogao le igoa.",
    err_sprite_exists: "O se sprite e iai lena igoa ua uma ona i ai.",
    err_project_exists: "O lo'o iai se galuega fa'atino e iai lea igoa.",
    err_no_content: "Leai se mea e teu ai.",
    err_no_changes: "Leai se suiga e teu.",
    err_delete_last_sheet: "Le mafai ona tape le pepa mulimuli.",
    err_extract_frames: "Le mafai ona aveese mai ni faavaa.",
    err_indexeddb: "Ua le mafai ona sefe i le lotoifale. Atonu e le lagolagoina e lau su'esu'ega IndexedDB.",
    msg_upload_success: "Manuia le la'uina: {0}",
    msg_upload_failed: "Ua le mafai ona la'uina: {0}",
    msg_save_success: "Sefe manuia.",
    msg_saving: "Fa'asaoina...",
    msg_multi_save_result: "Fa'asaoina {0} aseta. {1} toilalo.",
    menu_title: "Menu",
    menu_save: "Faasaoina",
    menu_save_all: "Faasaoina Uma",
    menu_support: "Faafesoota'i le Lagolago",
    label_local_storage: "Teuga Fa'alotoifale",
    label_sign_in: "Saini ese j",
    modal_export_title: "auina atu i fafo Sprite",
    label_filename: "igoa faila",
    label_format: "Fa'asologa",
    action_export_confirm: "Lafoa'i atu",
};

export default translations;
